const maintenanceCardLabel = {
  description: 'Descrição',
  value: 'Valor',
  company: 'Empresa',
  sendToMaintenanceDate: 'Data Prevista de Envio para Manutenção',
  returnFromMaintenanceDate: 'Data Prevista de Retorno da Manutenção',
  warranty: 'Prazo de Garantia',
  expiration: 'Prazo de Validade',
};

export default maintenanceCardLabel;